import axios from 'axios'

export default async (code, nameProduct) => {
    const route = process.env.VUE_APP_API_ROUTE + '/g_bar_code/generate'
    let response = await axios.get(route, {
        params: {
            code: code,
        },
    })

    const base64string = response.data
    var a = document.createElement('a')
    a.href = 'data:image/png;base64,' + base64string
    a.download = `${nameProduct}-${code}.png`
    a.click()
}
